import { TixTime } from '@/TixTime/TixTime'
import { API } from '@/api/API'
import { EventDetails } from '@/api/types/processedEntities'
import { timezone } from '@/helpers/Environment'
import { quantitiesPayload } from '@/helpers/TicketTypeQuantities'

export type CalendarApiResponse = EventBasicDateData[] | EventDateData[]

export async function fetchCalendarForTicketGroupIDs(
  event: EventDetails,
  ticketGroupIds: string[],
): Promise<EventBasicDateData[]> {
  const query = {
    _format: 'extended',
    'ticket_group_id._in': ticketGroupIds.join(','),
  }

  if (event.event_type !== 'single') {
    query['start_datetime._lt'] = new TixTime(null, event.venue.timezone).startOfMonthOneYearAhead().format()
  }

  const response = await API.getCached<'calendar'>(`events/${event.id}/calendar`, { query })
  return response.calendar._data
}

export async function fetchCalendarForTicketTypes(
  eventId: string,
  quantities: TicketTypeQuantities,
  includePricing: boolean,
): Promise<CalendarApiResponse> {
  const query = {
    _format: includePricing ? 'price' : 'extended',
    'start_datetime._lt': new TixTime(null, timezone).startOfMonthOneYearAhead().format(),
  }
  const body = quantitiesPayload(quantities)
  const response = await API.post<'calendar'>(`events/${eventId}/calendar`, { query, body })
  return response.calendar._data
}
